import React, { Component } from 'react'
import { connect } from 'react-redux'
import LangContext, { i18n } from 'modules/shared/context/langContext'
import { Formik } from 'formik'
import * as yup from 'yup'
import moment from 'moment'
import { checkPermissions } from '../../../../lib/helper'
import {
  Button,
  Row,
  Col,
  Form,
  DatePicker,
  Input,
  Drawer,
  Tooltip,
  Select,
} from 'antd'

const { Option } = Select
const FormItem = Form.Item
const { RangePicker } = DatePicker

class FormSearch extends Component {
  constructor(props) {
    super(props)
    this.state = {
      date_format: 'DD/MM/YYYY',

      initialValues: {
        company_id: this.props.auth.profile.company_id,
        vehicle_code: '',
        plate_no: '',
        device_code: '',
        // ย้อนหลัง 7 วัน
        search_date: [moment().subtract(6, 'days'), moment()],
        device_type: null,
      },

      /*  32 = HNT
          37 = J40
          40 = ISU
      */

      deviceTypeList: [
        {
          value: '32',
          label: 'HNT',
        },
        {
          value: '37',
          label: 'J40',
        },
        {
          value: '40',
          label: 'ISU',
        },
      ],
    }
  }

  componentDidMount() {
    if (
      checkPermissions(
        this.props.auth.profile.permissions,
        'cameraStatusDashboard',
        'can_special_1'
      )
    ) {
      // สามารถ filter company ได้
      this.setState({
        initialValues: {
          ...this.state.initialValues,
          company_id: null,
        },
      })
    } else {
      // ไม่สามารถ filter company ได้
      this.setState({
        initialValues: {
          ...this.state.initialValues,
          company_id: this.props.auth.profile.company_id,
        },
      })
    }
  }

  disabledDate = (current) => {
    // ไม่ให้เลือกวันที่มากกว่าวันปัจจุบัน
    return current && current > moment().endOf('day')
  }

  render() {
    let { date_format, initialValues, deviceTypeList } = this.state
    let { handleSearch, visible, handleClose } = this.props
    const { company_list } = this.props.cameraStatusDashboard

    return (
      <Drawer
        title={i18n[this.props.language].s.search}
        width={500}
        placement='right'
        onClose={handleClose}
        maskClosable={true}
        visible={visible}
        className='camera-status-dashboard-drawer-component'
      >
        <Formik
          enableReinitialize={true}
          initialValues={initialValues}
          validationSchema={yup.object().shape({
            search_date: yup
              .array()
              .required(i18n[this.props.language].r.required)
              .test(
                'checkDate',
                i18n[this.props.language].o.over1Month,
                (value) => {
                  if (value) {
                    // value ต้องไม่เกิน 31
                    let diff = moment(value[1]).diff(moment(value[0]), 'days')
                    if (diff >= 31) {
                      return false
                    }
                  }
                  return true
                }
              ),
          })}
          onSubmit={(values) => {
            // ส่งค่าให้กับ function เพื่อค้นหาข้อมูล
            handleSearch(values)
          }}
          ref={(formik) => (this.formik = formik)}
          render={({
            values,
            errors,
            touched,
            handleChange,
            handleBlur,
            handleSubmit,
            handleFocus,
            setFieldValue,
            resetForm,
          }) => (
            <>
              <Form onSubmit={handleSubmit}>
                <>
                  {/* start บริษัท */}
                  {checkPermissions(
                    this.props.auth.profile.permissions,
                    'cameraStatusDashboard',
                    'can_special_1'
                  ) && (
                    <Row>
                      <Col span={24}>
                        <FormItem
                          validateStatus={
                            touched.company_id && errors.company_id && 'error'
                          }
                          help={touched.company_id && errors.company_id}
                          label={
                            <span className='label-font-style'>
                              {i18n[this.props.language].c.company}
                            </span>
                          }
                        >
                          <div>
                            <Select
                              name='company_id'
                              className='select-style'
                              showSearch
                              optionFilterProp='title'
                              onChange={(value) => {
                                setFieldValue('company_id', value)
                              }}
                              placeholder={i18n[this.props.language].c.company}
                              value={values.company_id}
                            >
                              <Option value={null} title='-'>
                                <span className='option-style'>{'-'}</span>
                              </Option>

                              {company_list.map((item, index) => {
                                return (
                                  <Option
                                    key={index}
                                    value={item.company_id}
                                    title={item.company_name}
                                  >
                                    <Tooltip
                                      placement='rightTop'
                                      title={`${item.company_name}`}
                                    >
                                      <span className='option-style'>
                                        {`${item.company_name}`}
                                      </span>
                                    </Tooltip>
                                  </Option>
                                )
                              })}
                            </Select>
                          </div>
                        </FormItem>
                      </Col>
                    </Row>
                  )}

                  {/* end บริษัท */}

                  {/* start รหัสรถ */}
                  <Row>
                    <Col span={24}>
                      <FormItem
                        validateStatus={
                          touched.vehicle_code && errors.vehicle_code && 'error'
                        }
                        help={touched.vehicle_code && errors.vehicle_code}
                        label={
                          <span className='label-font-style'>
                            {i18n[this.props.language].v.vehicleCode}
                          </span>
                        }
                      >
                        <div>
                          <Input
                            name='vehicle_code'
                            value={values.vehicle_code}
                            onChange={(e) => {
                              setFieldValue('vehicle_code', e.target.value)
                            }}
                          />
                        </div>
                      </FormItem>
                    </Col>
                  </Row>
                  {/* end รหัสรถ */}

                  {/* start ทะเบียนรถ*/}
                  <Row>
                    <Col span={24}>
                      <FormItem
                        validateStatus={
                          touched.plate_no && errors.plate_no && 'error'
                        }
                        help={touched.plate_no && errors.plate_no}
                        label={
                          <span className='label-font-style'>
                            {i18n[this.props.language].v.vehiclePlateNo}
                          </span>
                        }
                      >
                        <div>
                          <Input
                            name='plate_no'
                            value={values.plate_no}
                            onChange={(e) => {
                              setFieldValue('plate_no', e.target.value)
                            }}
                          />
                        </div>
                      </FormItem>
                    </Col>
                  </Row>
                  {/* end ทะเบียนรถ */}

                  {/* start device code*/}
                  <Row>
                    <Col span={24}>
                      <FormItem
                        validateStatus={
                          touched.device_code && errors.device_code && 'error'
                        }
                        help={touched.device_code && errors.device_code}
                        label={
                          <span className='label-font-style'>
                            {i18n[this.props.language].d.deviceCode}
                          </span>
                        }
                      >
                        <div>
                          <Input
                            name='device_code'
                            value={values.device_code}
                            onChange={(e) => {
                              setFieldValue('device_code', e.target.value)
                            }}
                          />
                        </div>
                      </FormItem>
                    </Col>
                  </Row>
                  {/* end device code */}

                  {/* start device type */}
                  <Row>
                    <Col span={24}>
                      <FormItem
                        validateStatus={
                          touched.device_type && errors.device_type && 'error'
                        }
                        help={touched.device_type && errors.device_type}
                        label={
                          <span className='label-font-style'>
                            {i18n[this.props.language].d.deviceType}
                          </span>
                        }
                      >
                        <div>
                          <Select
                            name='device_type'
                            className='select-style'
                            showSearch
                            optionFilterProp='title'
                            onChange={(value) => {
                              setFieldValue('device_type', value)
                            }}
                            placeholder={i18n[this.props.language].d.deviceType}
                            value={values.device_type}
                          >
                            <Option value={null} title='-'>
                              <span className='option-style'>{'-'}</span>
                            </Option>

                            {deviceTypeList.map((item, index) => {
                              return (
                                <Option
                                  key={index}
                                  value={item.value}
                                  title={item.label}
                                >
                                  <Tooltip
                                    placement='rightTop'
                                    title={`${item.label}`}
                                  >
                                    <span className='option-style'>
                                      {`${item.label}`}
                                    </span>
                                  </Tooltip>
                                </Option>
                              )
                            })}
                          </Select>
                        </div>
                      </FormItem>
                    </Col>
                  </Row>

                  {/* start วันที่ต้องการค้นหาข้อมูล === search_date */}
                  <Row>
                    <Col span={24}>
                      <FormItem
                        validateStatus={
                          touched.search_date && errors.search_date && 'error'
                        }
                        help={touched.search_date && errors.search_date}
                        label={
                          <span className='label-font-style'>
                            {i18n[this.props.language].d.date}
                          </span>
                        }
                      >
                        <div>
                          <RangePicker
                            name='search_date'
                            defaultValue={[moment().startOf('month'), moment()]}
                            format={date_format}
                            allowClear={false}
                            value={values.search_date}
                            onChange={(value) => {
                              setFieldValue('search_date', value)
                            }}
                            style={{ width: '100%' }}
                            disabledDate={this.disabledDate}
                          />
                        </div>
                      </FormItem>
                    </Col>
                  </Row>
                  {/* end วันที่ต้องการค้นหาข้อมูล */}

                  {/* start search button */}
                  <Row>
                    <Col span={24} align='right'>
                      <FormItem>
                        <div>
                          <Button
                            type='button'
                            onClick={() => {
                              handleClose()
                            }}
                            className='button-search-style'
                          >
                            <span>{i18n[this.props.language].c.cancel}</span>
                          </Button>
                          <Button
                            type='primary'
                            htmlType='submit'
                            className='button-search-style'
                          >
                            <span>{i18n[this.props.language].a.apply}</span>
                          </Button>
                        </div>
                      </FormItem>
                    </Col>
                  </Row>
                </>
                {/* end search button */}
              </Form>
            </>
          )}
        />
      </Drawer>
    )
  }
}

export default connect(
  ({ cameraStatusDashboard, auth, auth: { profile }, ui: { language } }) => ({
    cameraStatusDashboard,
    auth,
    profile,
    language,
  }),
  {}
)(FormSearch)
